export default "__VITE_ASSET__CeHDzIMQ__"